export const CanalesIngreso = [
    "DIRECTO",
    "COMERCIAL"
];


// WEBPACK FOOTER //
// ./src/co/sura/dominio/general/modelo/CanalesIngreso.ts